module.exports = "/assets/crow.png";